<div class="wrapper">
  <div *ngFor="let badge of badges">
    <div class="badge {{ badge.class }}" [matTooltip]="badge.label | translate">
      <fa-icon *ngIf="badge.icon" [icon]="badge.icon" size="md"></fa-icon>
      <mat-icon *ngIf="badge.matIcon">{{ badge.matIcon }}</mat-icon>
      <span *ngIf="badge.text">{{ badge.text }}</span>
    </div>
  </div>
</div>
